<template>
  <el-popconfirm v-if="success" title="是否确认撤回？" @confirm="handleWithdrawClick">
    <template #reference>
      <div class="back">
        <i class="icon-arrow-go-back-line t-iconfont" />
        <span>撤回</span>
      </div>
    </template>
  </el-popconfirm>

  <div
    v-else
    class="ai-polish"
    :class="{ 'ai-polish--disabled': disabled || loading }"
    @click="handlePolishClick"
  >
    <i class="icon-quill-pen-ai-line t-iconfont" />
    <div class="text">{{ loading ? 'AI 润色中...' : 'AI 帮我润色' }}</div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { optPrompt } from '@/api/ai-board'

const props = defineProps({
  disabled: Boolean,
  params: {
    type: Object,
    default: () => ({})
  }
})

const emits = defineEmits(['start', 'end', 'success', 'withdraw'])

const loading = ref(false)
const success = ref(false)

const finishPolish = () => {
  loading.value = false
  emits('end')
}

const startPolish = async (data = {}) => {
  if (props.disabled || loading.value || !data.sceneType || !data.userPrompt) return ''
  loading.value = true
  emits('start')
  try {
    const res = await optPrompt(data)
    const newPrompt = res?.result?.newPrompt || ''

    if (newPrompt) {
      success.value = true
      emits('success', newPrompt)
    }
    return newPrompt
  } finally {
    finishPolish()
  }
}

const handlePolishClick = () => {
  if (props.disabled || loading.value) return
  startPolish(props.params)
}

const handleWithdrawClick = () => {
  if (loading.value) return
  success.value = false
  emits('withdraw')
}

const reset = () => {
  loading.value = false
  success.value = false
}

defineExpose({
  success,
  reset
})
</script>

<style scoped lang="less">
.back {
  width: fit-content;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 15px;
  font-size: 12px;
  color: #969799;
  .icon-arrow-go-back-line {
    font-size: 14px;
    margin-right: 4px;
  }
}

.ai-polish {
  width: fit-content;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 15px;

  &--disabled {
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
  }

  &__loading {
    animation: ai-polish-loading 1s linear infinite;
  }

  .text {
    margin-left: 2px;
    font-size: 14px;
    background: linear-gradient(279deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
  }
  .icon-quill-pen-ai-line {
    background: linear-gradient(279deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
  }
}

.t-iconfont {
  font-size: 16px;
}

@keyframes ai-polish-loading {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
